import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import OEAnimateHelper from '../../lib/animation/oe-animate-helper';
import OEToolbox from '../../lib/tools/oe-toolbox';
import {OEFunctionFragmentType, OEFunctionShowMediaFlags} from '../controller/notes/function/oe-function-model';
import {OEMediaViewerContentType, OEMediaViewerContentSizeMode, OEMediaViewerContent, OEMediaViewerDataSourceIntrinsic} from '../media-viewer/oe-media-viewer-model';
import OEMediaViewerController from '../media-viewer/oe-media-viewer-controller';
import {OEWindowComponent} from '../../lib/components/oe-window';
import {OEModal} from '../modals/oe-modal';

export default class OEMediaFunctionFragmentView extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            style: this.getStyle(),
            mediaViewerVisible: false,
            mediaViewerDataSource: null,
            showMediaDataSource: null,
            autoclose: false
        };

        this.onLanguageChanged = this.onLanguageChanged.bind(this);
        this.onFunctionFragmentApplied = this.onFunctionFragmentApplied.bind(this);

        this.onEnded = this.onEnded.bind(this);
        this.onShowMedia = this.onShowMedia.bind(this);
        this.onCloseBtnPressed = this.onCloseBtnPressed.bind(this);
        this.onProgressSliderStart = this.onProgressSliderStart.bind(this);
        this.onProgressSliderEnd = this.onProgressSliderEnd.bind(this);
        this.onModalCloseBtnPressed = this.onModalCloseBtnPressed.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.ignoreInsets != nextProps.ignoreInsets || !OEToolbox.shallowEqual(this.props.insets, nextProps.insets) || !OEToolbox.shallowEqual(this.props.animate, nextProps.animate))     {
            this.updateStyle(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.onLanguageChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.functionFragmentApplied, this.onFunctionFragmentApplied);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.onLanguageChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.functionFragmentApplied, this.onFunctionFragmentApplied);
    }

    updateLanguage()    {

    }

    getStyle(props) {
        props = props || this.props;

        if(props.ignoreInsets)    {
            return {
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px'
            };
        }

        let animate = props.animate;
        if(typeof(animate) === 'boolean')   animate = {top: animate, right: animate, bottom: animate, left: animate};

        return {
            top: props.insets.top.toString() + 'px',
            right: props.insets.right.toString() + 'px',
            bottom: props.insets.bottom.toString() + 'px',
            left: props.insets.left.toString() + 'px',
            transition: OEAnimateHelper.transitionForInsets(animate)
        };
    }

    updateStyle(props)   {
        this.setState({style: this.getStyle(props)});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.savedAnimationMode = null;
            this.setState({mediaViewerVisible: false, mediaViewerDataSource: null, showMediaDataSource: null});
            return;
        }

        this.updateLanguage();
    }

    pauseAnimation()    {
        this.savedAnimationMode = null;
        if(!this.oe.isReady())  return;

        if(this.oe.sharedInterface.getUIControllerMediaCenter().getEnabled() && this.oe.sharedInterface.getUIControllerMediaCenter().getAnimationMode() === this.oe.Module.AnimationMode.play)    {

            this.savedAnimationMode = {mediaCenter: this.oe.Module.AnimationMode.play};
            this.oe.sharedInterface.getUIControllerMediaCenter().setAnimationMode(this.oe.Module.AnimationMode.pause);

        } else if(this.oe.sharedInterface.getUIControllerPresentation().getAnimationMode() === this.oe.Module.AnimationMode.play)    {

            this.savedAnimationMode = {presentation: this.oe.Module.AnimationMode.play};
            this.oe.sharedInterface.getUIControllerPresentation().setAnimationMode(this.oe.Module.AnimationMode.pause);
        }
    }

    applySavedAnimationMode()   {
        if(!this.oe.isReady() || !this.savedAnimationMode)  return;

        if(this.savedAnimationMode.mediaCenter) {
            this.oe.sharedInterface.getUIControllerMediaCenter().setAnimationMode(this.savedAnimationMode.mediaCenter);
        } else if(this.savedAnimationMode.presentation) {
            this.oe.sharedInterface.getUIControllerPresentation().setAnimationMode(this.savedAnimationMode.presentation);
        }

        this.savedAnimationMode = null;
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.mediaViewerVisible !== this.state.mediaViewerVisible)     {
            if(this.state.mediaViewerVisible)   {
                this.pauseAnimation();
            } else {
                this.applySavedAnimationMode();
            }
        }
    }

    onLanguageChanged() {
        this.updateLanguage();
    }

    onFunctionFragmentApplied(message, userInfo) {
        if(userInfo.type !== OEFunctionFragmentType.showMedia)  return;

        let si = this.oe.sharedInterface;

        let mediaType = userInfo.mediaType;
        let contentType = OEMediaViewerContentType.fromMediaType(mediaType);

        this.isProgressSliding = false;
        this.contentType = contentType;

        let path = userInfo.path;
        if(userInfo.pathId) path = si.getLocalizedStringEnc(userInfo.pathId);

        if(contentType === OEMediaViewerContentType.dummy || !path)  {
            this.setState({mediaViewerVisible: false, mediaViewerDataSource: null, showMediaDataSource: null, autoclose: false});
            return;
        }

        let flags = typeof(userInfo.flags) === 'number' ? userInfo.flags : OEFunctionShowMediaFlags.none;

        path = 'app/oe/' + this.oe.Module.filePackagePathURL + path;
        
        let dataSource = new OEMediaViewerDataSourceIntrinsic(
            new OEMediaViewerContent(
                contentType,
                path,
                !!(flags & OEFunctionShowMediaFlags.autoplay),
                null,
                {x: 0, y: 0, z: 0, w: 0},
                contentType == OEMediaViewerContentType.image ? {mode: OEMediaViewerContentSizeMode.fill} : null,
                false
            )
        );

        this.setState({mediaViewerVisible: true, mediaViewerDataSource: dataSource, showMediaDataSource: null, autoclose: !!(flags & OEFunctionShowMediaFlags.autoclose)});
    }

    render()    {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                
                {!(this.state.mediaViewerVisible) ? null :
                    <OEWindowComponent className={'media-function-fragment-view ' + this.props.className}>
                        <div className="backdrop"/>
                        <div className="media-container" style={this.state.style}>
                            <OEMediaViewerController
                                dataSource={this.state.mediaViewerDataSource}
                                showCloseBtn={true}
                                showControlsWhenWindow={true}
                                controlsContentAlignedWhenWindowed={true}
                                showNextPrevButtons={false}
                                onEnded={this.onEnded}
                                onShowMedia={this.onShowMedia}
                                onCloseBtnPressed={this.onCloseBtnPressed}
                                onProgressSliderStart={this.onProgressSliderStart}
                                onProgressSliderEnd={this.onProgressSliderEnd}
                            />
                        </div>
                    </OEWindowComponent>
                }

                <OEModal
                    className="fullscreen-modal"
                    isOpen={Boolean(this.state.mediaViewerVisible && this.state.showMediaDataSource)}
                    noHeader={true}
                    hasCloseBtn={false}
                >
                    <OEMediaViewerController
                        className="show-media-media-viewer"
                        dataSource={this.state.showMediaDataSource}
                        showCloseBtn={true}
                        showControlsWhenWindow={true}
                        controlsContentAlignedWhenWindowed={false}
                        showNextPrevButtons={false}
                        onCloseBtnPressed={this.onModalCloseBtnPressed}
                    />
                </OEModal>

            </React.Fragment>
        );
    }

    onEnded()   {
        if(this.contentType === OEMediaViewerContentType.video && this.state.autoclose && !this.isProgressSliding)    this.setState({mediaViewerVisible: false});
    }

    onShowMedia()   {
        let resourcePath = 'app/oe/' + this.oe.Module.filePackagePathURL;

        let content = new OEMediaViewerContent(
            OEMediaViewerContentType.image,
            resourcePath + path,
            false,
            null,
            null,
            {mode: OEMediaViewerContentSizeMode.fill}
        ); 

        this.setState({showMediaDataSource: new OEMediaViewerDataSourceIntrinsic(content)});
    }

    onCloseBtnPressed() {
        this.setState({mediaViewerVisible: false});
    }

    onProgressSliderStart()  {
        this.isProgressSliding = true;
    }

    onProgressSliderEnd()  {
        this.isProgressSliding = false;
    }

    onModalCloseBtnPressed()    {
        this.setState({showMediaDataSource: null});
    }
}

OEMediaFunctionFragmentView.defaultProps = {
    moduleId: '',
    className: '',
    ignoreInsets: false,
    insets: {top: 0, right: 0, bottom: 0, left: 0},
    animate: false
};

OEMediaFunctionFragmentView.propTypes = {
    moduleId: PropTypes.string,
    className: PropTypes.string,
    ignoreInsets: PropTypes.bool,
    insets: PropTypes.shape({
        top: PropTypes.number,
        right: PropTypes.number,
        bottom: PropTypes.number,
        left: PropTypes.number
    }),
    animate: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
        top: PropTypes.bool,
        right: PropTypes.bool,
        bottom: PropTypes.bool,
        left: PropTypes.bool
    })])
};